import { Component, Input } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../../marketplace-transloco-scope';

@Component({
  selector: 'yat-subscription-cancel-confirmation-text',
  templateUrl: './subscription-cancel-confirmation-text.component.html',
  styleUrls: ['./subscription-cancel-confirmation-text.component.scss'],
  providers: [provideTranslocoScope(MARKETPLACE_TRANSLOCO_SCOPE)]
})
export class SubscriptionCancelConfirmationTextComponent {
  @Input()
  endOfPeriod?: Date;

  @Input()
  productName: string;

  @Input()
  terminationDate?: Date;

  @Input()
  liveLicense: boolean = true;
}
